import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import ReactPlayer from 'react-player'

import Modal from '../../mini/Modal'
import QuestIcon from '../../mini/QuestIcon'
import H2 from '../../typography/headers/H2'
import H5 from '../../typography/headers/H5'
import P2 from '../../typography/paragraphs/P2'
import CloseIcon from '../../../static/images/modal/close.svg'
import CloseIconHover from '../../../static/images/modal/close_hover.svg'

import { hideModal } from '../../../actions/modal'

const TopContainer = styled.div`
  position: relative;
  margin: 0 auto;
  width: 1024px;
  height: auto;
  padding: 25px 0;
`

const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: left;
`

const ResourceInfoContainer = styled.div`
  margin: 0 auto;
  width: 1024px;
  height: auto;
  padding: 25px 0 50px;
  text-align: left;
`

const Close = styled.div`
  position: absolute;
  right: 0;
  top: 50%;
  height: 18px;
  width: 18px;
  background: no-repeat url(${CloseIcon});
  background-size: contain;
  cursor: pointer;
  transform: translateY(-50%);
  transition: 0.4s all;

  &:hover {
    background: no-repeat url(${CloseIconHover});
    background-size: contain;
  }
`

class VideoViewer extends Component {
  render() {
    const { resource, activity, quest, dispatch } = this.props

    return (
      <Modal
        width={1400}
        percentHeight={100}
        background={'#243646'}
        opacity={'.9'}
        allowInnerScroll
        closeCallback={() => dispatch(hideModal('VIDEO_VIEWER'))}
      >
        <div style={{ height: 'auto' }}>
          <TopContainer>
            <InfoContainer>
              <QuestIcon
                heightWidth={40}
                icon_image_url={quest.icon_image_url}
                showTypeIcon={quest.type && Boolean(quest.type.id)}
                questTypeId={quest.type ? quest.type.id : null}
                questTypeIconSize={14}
              />
              <div style={{ width: '850px', marginLeft: '15px' }}>
                {/* <H5 style={{ color: '#ffffff' }}></H5> */}
                <H5 className="text-truncate" style={{ color: '#ffffff' }}>
                  {quest.name}
                </H5>
                <P2 className="text-truncate" style={{ color: '#ffffff' }}>
                  Activity {this.getActivityNumber()}: {activity.name}
                </P2>
              </div>
              <Close onClick={() => dispatch(hideModal('VIDEO_VIEWER'))} />
            </InfoContainer>
          </TopContainer>
          <ReactPlayer
            url={resource.url}
            playing
            controls
            playsinline
            width={1024}
            height={624}
            style={{
              margin: '0 auto'
            }}
            config={{
              youtube: this.getYouTubeConfig()
            }}
          />
          <ResourceInfoContainer>
            <H2 style={{ color: '#ffffff' }}>{resource.name}</H2>
            <P2 style={{ marginTop: '20px', color: '#ffffff' }}>
              {resource.description}
            </P2>
          </ResourceInfoContainer>
        </div>
      </Modal>
    )
  }

  getActivityNumber() {
    const { activities, activity } = this.props
    const index = activities.findIndex(a => a.id === activity.id) + 1
    // depending on where this component is implemented
    return index > 0
      ? index
      : activities.findIndex(a => a.id === activity.id) + 1
  }

  getYouTubeConfig() {
    const { resource } = this.props
    const config = {
      playerVars: {
        rel: 0,
        iv_load_policy: 3,
        showinfo: 0
      }
    }

    if (resource.start_time) {
      config.playerVars.start = resource.start_time
    }

    if (resource.end_time) {
      config.playerVars.end = resource.end_time
    }

    return config
  }
}

VideoViewer.propTypes = {
  closeCallback: PropTypes.func,
  activity: PropTypes.object,
  resource: PropTypes.object,
  quest: PropTypes.object,
  dispatch: PropTypes.func,
  activities: PropTypes.array
}

export default connect()(VideoViewer)
export { VideoViewer as VideoViewerDisconnected }



// WEBPACK FOOTER //
// ./src/components/quest/activity/VideoViewer.js